import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Paper, Button, TableContainer, Table,
         TableBody, TableRow, TableCell, Typography, IconButton } from "@material-ui/core";
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import moment from "moment-timezone";
import t from "../../../languages/pl";
import TableHeader from '../../Common/TableHeader';
import { notArrayOrEmpty } from '../../../utils/helpers';
import NoData from '../../Common/NoDataRow';
import guid from '../../../utils/guid';
import { displayDateFormat } from '../../../utils/staticData';
import AddHoliday from './AddHoliday';
import ConfirmationDialog from "../../Common/ConfirmationDialog";
import TableContainerWithHeight from './../../Common/TableContainerWithHeight';
import PaperContainer from '../../Common/PaperContainer';

const useStyles = theme => ({
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: theme.spacing(1)
    },
    buttons: {
        display: "flex",
        justifyContent: "flex-end"
    },
    cell: {
        padding: theme.spacing(1),
        textAlign: "center"
    }
});

const tableHeader = [t.date, t.description, t.delete];

const Holidays = props => {
    const { classes, tableHeight, title, holidays, onHolidayAdd, onDelete, deleteText } = props;
    const [open, setOpen] = useState(false);
    const [holidayDeleteDialog, setHolidayDeleteDialog] = useState(false);
    const [holidayId, setHolidayId] = useState(null);


    const onDeleteClick = (id) => {
        setHolidayDeleteDialog(true);
        setHolidayId(id);
    };

    const onConfirmClick = (id) => {
        onDelete(id);
    };

    const handleHolidayAdd= (data => {
        onHolidayAdd && onHolidayAdd(data);
        setOpen(false);
    });

    const printTable = data => {
        if(notArrayOrEmpty(data))
            return <NoData colSpan={3} />;
        return data.map(row => (
            <TableRow key={guid()}>
                <TableCell className={classes.cell}>
                    {moment.unix(row.data).format(displayDateFormat)}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.opis}
                </TableCell>
                <TableCell className={classes.cell}>
                    <IconButton
                        size="small"
                        onClick={() => onDeleteClick(row.swieto_id)}
                    >
                        <DeleteSweepIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
        ));
    };

    return (
        <PaperContainer>
            <div className={classes.header}>
                <Typography variant="subtitle1">
                    {title}
                </Typography>
                <div className={classes.buttons}>
                     <Button
                        variant="contained"
                        color="primary"
                        onClick={() => setOpen(true)}
                    >
                        {t.add}
                    </Button>
                </div>
            </div>
            <TableContainerWithHeight height={tableHeight - 48 - 16}>
                <Table stickyHeader>
                    <TableHeader data={tableHeader} />
                    <TableBody>
                        {printTable(holidays)}
                    </TableBody>
                </Table>
            </TableContainerWithHeight>
            <AddHoliday
                title={t.addHoliday}
                open={open}
                onClose={() => setOpen(false)}
                onSubmit={handleHolidayAdd}
            />
            <ConfirmationDialog
                open={holidayDeleteDialog}
                onClose={() => setHolidayDeleteDialog(false)}
                id={holidayId}
                onSubmit={(id) => onConfirmClick(id)}
                action={deleteText}
            />
        </PaperContainer>
    );
};

Holidays.propTypes = {
    tableHeight: PropTypes.number,
    classes: PropTypes.object,
    title: PropTypes.string,
    holidays: PropTypes.array,
    onHolidayAdd: PropTypes.func,
    onDelete: PropTypes.func,
    deleteText: PropTypes.string,
};

export default withStyles(useStyles)(Holidays);
